export default __webpack_public_path__ + "static/media/Quotation.3a934323.png";